export default __webpack_public_path__ + "static/media/Optimity-Team-Sample.305bf312.csv";